import React from 'react'
import BlockContent from '@sanity/block-content-to-react'
import { Text, Box, Flex, styled } from '@sitewerk/juraholzbau-design-system'
import Img from 'gatsby-image/withIEPolyfill'
import { getFluidGatsbyImage } from 'gatsby-source-sanity'
import * as sanity from '../lib/sanity'
import { LearnMoreLink } from './learn-more-link'
import { ContentSlider } from './content-slider'
import { SingleQuote } from './single-quote'

const CaptionedImage = ({ asset, caption }) => (
  <Flex
    data-component="captioned-image"
    flexDirection={['column', null, null, 'row']}
    alignItems={['flex-start', null, null, 'flex-end']}
    mb={4}
  >
    <Box width={[1, null, null, 3 / 4]} boxShadow={0}>
      <Img
        objectFit="cover"
        objectPosition="50% 50%"
        fluid={getFluidGatsbyImage(asset, { maxWidth: 1920 }, sanity.config)}
        alt={caption}
      />
    </Box>

    <Box width={1 / 4}>
      <Text m={0} my={3} fontSize={0} ml={[0, 0, 0, 4]} textColor="neutral.500">
        {caption}
      </Text>
    </Box>
  </Flex>
)

const RichtTextFormat = styled(Box)`
  display: block;

  > div {
    > [data-component] {
      margin-top: 72px;
      margin-bottom: 72px;
    }

    > h3 {
      font-weight: 600;
      line-height: 24px;
      font-size: 24px;
      margin: 0;
      margin-bottom: 24px;
    }

    > p {
      font-weight: 300;
      line-height: 32px;
      font-size: 18px;
      margin: 0;
      margin-top: 24px;
      margin-bottom: 24px;
    }

    > * + h4 {
      font-size: 18px;
      margin-top: 48px;
    }

    > * + h3 {
      margin-top: 72px;
    }
  }
`

export const RichText: React.FC<{
  blocks: any
  TextElement?: React.ReactNode
}> = ({ TextElement, ...props }) => (
  <RichtTextFormat fontFamily="default">
    <BlockContent
      {...props}
      serializers={{
        list: props => {
          return (
            <Text
              as="ul"
              lineHeight={2}
              fontSize={2}
              fontWeight={300}
              textColor="neutral.300"
            >
              {props.children}
            </Text>
          )
        },
        types: {
          captionedImage: ({ node }) => {
            return <CaptionedImage caption={node.caption} asset={node.asset} />
          },
          contentSlider: ({ node }) => {
            return <ContentSlider images={node.images} />
          },
          quote: ({ node }) => {
            return <SingleQuote from={node.from} text={node.text} />
          },
          linkToService: ({ node }) => {
            return (
              <Box mt={3}>
                <LearnMoreLink
                  to={`/dienstleistungen/${node.service.parentServiceSlug}/${node.service.slug}`}
                >
                  {node.text}
                </LearnMoreLink>
              </Box>
            )
          }
        }
      }}
    />
  </RichtTextFormat>
)
